export default "__VITE_ASSET__996fb5c8__"